import { CustomFieldProp } from 'src/admin/customFields/entities/customFields.entity';
import { Tag } from 'src/tags/models/tagsApi.types';
import { ActivationAction } from '../../Products/actions/types/activationActionsTypes';
import { mapSimDTO } from '../Inventory/utils/simListResponseParsers';
import { MNOStatus } from './mnoStatus';
import { SessionStatus } from './sessionStatus';
import { SubscriptionStatus } from '../../SubscriptionStatus/constants/subscriptionStatus';
import { ValuesType } from 'utility-types';

export type Localization = {
  value: string;
};

export type RatDisplayInfo = {
  code: number;
  shortCode: string;
  friendlyName: string;
  tooltip: string;
};

export type NetworkLookupTranslation = {
  mcc: string;
  mnc: string;
  plmn?: string | null;
  tadig?: string | null;
  isoCode: string;
  countryName: string;
  operatorName?: string | null;
  friendlyName: string;
  tooltip: string;
};

export type NetworkCodeTranslation = {
  mccMnc?: NetworkLookupTranslation | null;
  plmn?: NetworkLookupTranslation | null;
  tadig?: NetworkLookupTranslation | null;
  rat?: RatDisplayInfo | null;
};

export type SimDTO = {
  iccid: string;
  imsi?: string | null;
  msisdn?: string | null;
  euicc?: string | null;
  imei?: string | null;
  organisation?: string | null;
  dcpEnterprise?: string | null;
  mobileNetworkOperator?: string | null;
  customerCommsPlan?: string | null;
  simType?: string;

  mnoStatus?: MNOStatus | null;
  mnoStatusEntryTime?: string | null;
  sessionStatus?: SessionStatus | null;
  sessionStartTime?: string | null;
  sessionEndTime?: string | null;
  sessionStatusLastUpdated?: string | null;
  apn?: string | null;
  localization?: Localization | null;
  liveDataUsage?: number | null;
  inboundLiveDataUsage?: number | null;
  outboundLiveDataUsage?: number | null;
  inMinuteUsage?: number | null;
  outMinuteUsage?: number | null;
  inTextUsage?: number | null;
  outTextUsage?: number | null;
  orderNumber?: string | null;
  connectionId?: string | null;
  customerReference?: string | null;
  managementIpAddress?: string | null;
  currentIpAddress?: string | null;
  accountRef?: number | null;
  accountName?: string | null;
  commsPlan?: string | null;
  mnoRatePlan?: string | null;
  accountIdentifier?: string | null;
  rasClient?: string | null;
  framedProtocol?: string | null;
  nasIpAddress?: string | null;
  serviceType?: string | null;
  userName?: string | null;
  timeZone?: string | null;
  cumulativeInputUsage?: number | null;
  cumulativeOutputUsage?: number | null;
  eventTimestamp?: string | null;
  ratType?: string | null;
  mcc?: string | null;
  mnc?: string | null;
  plmn?: string | null;
  tadig?: string | null;
  isoCode?: string | null;
  countryName?: string | null;
  operatorName?: string | null;
  ratDisplayInfo?: RatDisplayInfo | null;
  region?: string | null;
  tags?: Tag[];
  customFields?: CustomFieldProp[];
  activeConfiguration?: string | null;
  productCode?: string | null;
  productType?: string | null;
  subscriptionStatus?: SubscriptionStatus | null;
  billingStatus?: SubscriptionStatus | null;
  activationAction?: ActivationAction | null;
  installerRef?: number | null;
  installerName?: string | null;
  networkCodeTranslation?: NetworkCodeTranslation | null;
};

export type SimData = ReturnType<typeof mapSimDTO>;

export type SimDataKeys = keyof SimDTO;

export type SessionDTO = {
  imsi: string;
  sessionStatus?: SessionStatus | null;
  sessionStatusLastUpdated?: string | null;
  sessionStartTime?: string | null;
  sessionEndTime?: string | null;
  cumulativeInputUsage?: number | null;
  cumulativeOutputUsage?: number | null;
  apn?: string | null;
  currentIpAddress?: string | null;
  rasClient?: string | null;
  framedProtocol?: string | null;
  nasIpAddress?: string | null;
  serviceType?: string | null;
  userName?: string | null;
  eventTimestamp?: string | null;
  ratType?: string | null;
  mcc?: string | null;
  mnc?: string | null;
  plmn?: string | null;
  tadig?: string | null;
  isoCode?: string | null;
  countryName?: string | null;
  operatorName?: string | null;
  ratDisplayInfo?: RatDisplayInfo | null;
  localization?: Localization | null;
};

export type SessionListDetailsDTO = {
  imsi: string;
  lastUpdated: string;
  currentIpAddress: string;
};
export const SIM_INVENTORY_ID_SELECTION = {
  ICCID: 'ICCID',
  IMSI: 'IMSI',
  MSISDN: 'MSISDN',
} as const;

export type SimId = ValuesType<typeof SIM_INVENTORY_ID_SELECTION>;
